import LoadableLoading from 'components/LoadableLoading'
import Loadable from 'react-loadable'

export default Loadable({
  loader: () =>
    import('./CreateChannelForm'),
  loading: LoadableLoading
})
